<app-nav [navLabel]="'RateOptics\u2122'">
    <div class="is-flex nav-data">
        <div class="date-label">{{ lastDataUpdateDescription }}</div>
        <div class="date">{{ lastDataUpdate | date: 'yyyy-MM-dd' }}</div>
        <i
            *ngIf="stationExceptions"
            class="fas fa-fw fa-warning station-exceptions-icon"
            aria-hidden="true"
            (click)="showStationExceptions()"
        ></i>
    </div>
</app-nav>
